var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 6.98579L3.67393 4.88054e-07L2.70244e-07 1.66869e-07L5.01241 6.98579L0 14L3.67393 14L9 6.98579Z","fill":"#18263F"}));
}

ChevronInline.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
